import { useMemo, useState } from "react";
import { FaCheckCircle } from "react-icons/fa";
import styles from "./WhyChooseUs.module.css";

const serviceItems = [
  {
    id: "medical-coding",
    title: "Medical Coding",
    image: "/img/whychooseus-img/medical-coding.webp",
    alt: "Medical coding support for healthcare providers",
  },
  {
    id: "rcm-services",
    title: "RCM Services",
    image: "/img/whychooseus-img/rcm.webp",
    alt: "Revenue cycle management services for medical practices",
  },
  {
    id: "virtual-assistant",
    title: "Virtual Assistant",
    image: "/img/whychooseus-img/virtual-assistance.webp",
    alt: "Virtual assistant support for healthcare operations",
  },
  {
    id: "virtual-medical-scribe",
    title: "Virtual Medical Scribe",
    image: "/img/whychooseus-img/virtual-scribe.webp",
    alt: "Virtual medical scribe support for physicians",
  },
];

const points = [
  "98% of claims are paid on the first try",
  "More efficiency to certified coding team",
  "Continuous follow-ups on denied and pending claims",
  "Fewer staffing problems",
  "Denial Management",
  "Save almost 75% on operating costs",
  "No need to train your staff",
  "Quick responses to billing questions",
];

export default function WhyChooseUs() {
  const [activeServiceId, setActiveServiceId] = useState(serviceItems[0].id);

  const activeService = useMemo(
    () =>
      serviceItems.find((item) => item.id === activeServiceId) ??
      serviceItems[0],
    [activeServiceId],
  );

  return (
    <section className={styles.section}>
      <div className={`container ${styles.shell}`}>
        <div className={styles.mediaColumn}>
          <div className={styles.imageCard}>
            <img
              key={activeService.id}
              className={styles.image}
              src={activeService.image}
              alt={activeService.alt}
            />
            <span
              key={`${activeService.id}-label`}
              className={styles.imageLabel}
            >
              {activeService.title}
            </span>
          </div>

          <div
            className={styles.serviceTabs}
            role="tablist"
            aria-label="Why choose us services"
          >
            {serviceItems.map((service) => {
              const isActive = service.id === activeService.id;

              return (
                <button
                  key={service.id}
                  type="button"
                  role="tab"
                  aria-selected={isActive}
                  className={`${styles.serviceTab} ${isActive ? styles.serviceTabActive : ""}`}
                  onClick={() => setActiveServiceId(service.id)}
                >
                  {service.title}
                </button>
              );
            })}
          </div>
        </div>

        <div className={styles.contentColumn}>
          <h2>Why Choose Physicians Success Partners?</h2>
          <p className={styles.description}>
            Our wide range of services, strong work ethic, professionalism, and
            use of the latest technology make us one of the best companies for
            outsourced revenue cycle management.
          </p>

          <div className={styles.pointsGrid}>
            {points.map((point) => (
              <article key={point} className={styles.pointCard}>
                <span className={styles.pointIcon}>
                  <FaCheckCircle />
                </span>
                <p>{point}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
